import {createContext, useContext} from "react";
import useAccommodations from "../../components/Accommodations/useAccommodations";
import useAccommodationUnitSelector from "../../components/Accommodations/useAccommodationUnitSelector";


const RatesContext = createContext();

export const useRates= () => useContext(RatesContext);

/*
 * Provider for the Rates page.
 * It provides the accommodations and the accommodation unit selector.
 * It is only needed for the planner because the QueryMonthDataLoader needs to know
 * the selected apartment and there is no other way to pass it except through the context.
 * The Planner should be refactored allow passing additional props to the QueryMonthDataLoader.
 */
export default function RatesProvider({children}) {

    const accommodations = useAccommodations();
    const accUnitSelector = useAccommodationUnitSelector(accommodations.accommodationUnits)

    const context = {
        accommodations,
        accUnitSelector
    }

    return <RatesContext.Provider value={context}>
        {children}
    </RatesContext.Provider>
}